module.exports = __webpack_public_path__ + "static/media/Money3.b3e0fd8f.svg";